import LOCALS from 'commons/locals';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import { CreateProductFormSchemaType } from '../common';
import { Control, Controller, useWatch } from 'react-hook-form';
import { InputNumber } from 'antd';
import { findLabelByValue } from 'commons/options';
import { CURRENCY_OPTION_LIST } from 'constant/currency';

const ProductReferencePrice = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  const currency = useWatch({ control, name: 'currency' });

  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.reference_price)}:</FormLabel>
      <Controller
        name="referencePrice"
        control={control}
        render={({ field }) => (
          <InputNumber
            addonBefore={
              currency ? findLabelByValue(currency, CURRENCY_OPTION_LIST) : null
            }
            {...field}
            className="w-full"
            max={100000000}
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={(value) => value!.replace(/\$\s?|(,*)/g, '') as any}
            placeholder={i18n.t(LOCALS.please_enter) || ''}
          />
        )}
      />
    </div>
  );
};

export default ProductReferencePrice;
